import { render, staticRenderFns } from "./up-comming-booking.vue?vue&type=template&id=30fe7a4e"
import script from "./up-comming-booking.vue?vue&type=script&lang=js"
export * from "./up-comming-booking.vue?vue&type=script&lang=js"
import style0 from "./up-comming-booking.vue?vue&type=style&index=0&id=30fe7a4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports